// extracted by mini-css-extract-plugin
module.exports = {"white100":"#fff","primary":"#400099","primaryD10":"#2b0066","Input__icon":"medkit__Input__Input__icon","Input__iconImage":"medkit__Input__Input__iconImage"};